import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import Mint from "mint-ui";
// import "mint-ui/lib/style.css";
// Vue.use(Mint);
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
import { Toast } from "vant";
Vue.prototype.$Toast = Toast;
Vue.config.productionTip = false;

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
// localStorage.setItem("token", "Bearer%20eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC90ZXN0LXJvbmdsaXUubWVkbGl2ZS5jblwvYXBpXC9jYXNcL2Nhcy11c2VyaW5mbyIsImlhdCI6MTYxMTY1NjAyNCwiZXhwIjoyMDUzMzI1NjAyNCwibmJmIjoxNjExNjU2MDI0LCJqdGkiOiJjUnJzQmRvbFRWVnN4TW9uIiwic3ViIjoxNzcsInBydiI6IjE0ZjE0MzRiNjUyOWFiOWM0ZTdhNzQ5ZDk4YTZjMTdlZWE4ZGQ5MDYifQ.IkNnRSCtlqv5mmzUaD6gz7ZWcTALHnhc4konEVDeDDs")
Vue.use(VideoPlayer);


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");